export default "__VITE_ASSET__CsNfPtF7__"